/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlQueryRelation
 */
export interface ControlQueryRelation {
    /**
     * 
     * @type {string}
     * @memberof ControlQueryRelation
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof ControlQueryRelation
     */
    relation: string;
    /**
     * 
     * @type {string}
     * @memberof ControlQueryRelation
     */
    obj: string;
}

/**
 * Check if a given object implements the ControlQueryRelation interface.
 */
export function instanceOfControlQueryRelation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "relation" in value;
    isInstance = isInstance && "obj" in value;

    return isInstance;
}

export function ControlQueryRelationFromJSON(json: any): ControlQueryRelation {
    return ControlQueryRelationFromJSONTyped(json, false);
}

export function ControlQueryRelationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlQueryRelation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': json['user'],
        'relation': json['relation'],
        'obj': json['obj'],
    };
}

export function ControlQueryRelationToJSON(value?: ControlQueryRelation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': value.user,
        'relation': value.relation,
        'obj': value.obj,
    };
}

